import React from "react";
import { useQuery } from "@tanstack/react-query";
import { FileText, FileSpreadsheet, Calendar } from "lucide-react";
import { api } from "@/lib/api";

export default function ReportsAdmin() {
  const { data: months = [], isLoading } = useQuery({ queryKey: ["report-months"], queryFn: () => api.reportMonths() });

  return (
    <div className="max-w-2xl">
      <h2 className="font-display text-2xl text-ink mb-1">Monthly Sales Reports</h2>
      <p className="text-sm text-muted2 mb-5">Download paid-order sales summaries per month.</p>
      {isLoading ? (
        <p className="text-muted2">Loading…</p>
      ) : months.length === 0 ? (
        <div className="text-center py-16 text-muted2" data-testid="reports-empty"><Calendar className="mx-auto text-line" size={40} /><p className="mt-3">No sales yet — reports appear once orders are paid.</p></div>
      ) : (
        <div className="space-y-3">
          {months.map((m) => (
            <div key={m.month} className="flex items-center justify-between rounded-xl border border-line p-4" data-testid={`report-month-${m.month}`}>
              <div>
                <p className="font-semibold text-ink">{m.label || m.month}</p>
                <p className="text-xs text-muted2">{m.orders} paid order{m.orders === 1 ? "" : "s"}</p>
              </div>
              <div className="flex gap-2">
                <a href={api.salesReportUrl(m.month, "pdf")} target="_blank" rel="noopener noreferrer" className="h-10 px-4 rounded-full bg-brand text-white text-sm font-semibold flex items-center gap-1.5" data-testid={`report-pdf-${m.month}`}><FileText size={15} /> PDF</a>
                <a href={api.salesReportUrl(m.month, "csv")} target="_blank" rel="noopener noreferrer" className="h-10 px-4 rounded-full border border-line text-ink text-sm font-semibold flex items-center gap-1.5" data-testid={`report-csv-${m.month}`}><FileSpreadsheet size={15} /> Excel</a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
